<vdr-card title="Corporate Discount" class="mb-2">
  <div class="flex" style="gap: 1rem">
    <div>Corporate discount configuration</div>
    <clr-toggle-wrapper>
      <input
        type="checkbox"
        clrToggle
        id="useCooperateDiscount"
        [formControl]="showCooperateDiscountControl"
      />
    </clr-toggle-wrapper>
  </div>

  <div *ngIf="showCooperateDiscountControl.value">
    <vdr-page-block>
      <vdr-action-bar>
        <vdr-ab-right>
          <button class="button primary mr-2" (click)="create()">
            {{ "common.create" | translate }}
          </button>
        </vdr-ab-right>
      </vdr-action-bar>
    </vdr-page-block>

    <vdr-data-table-2
      class="mt-2"
      id="cooperate-discount-table"
      [items]="items$ | async"
      [itemsPerPage]="itemsPerPage$ | async"
      [totalItems]="totalItems$ | async"
      [currentPage]="currentPage$ | async"
      [filters]="filters"
      (pageChange)="setPageNumber($event)"
      (itemsPerPageChange)="setItemsPerPage($event)"
    >
      <vdr-dt2-column
        [heading]="'quantity' | translate"
        id="quantity"
        [hiddenByDefault]="false"
      >
        <ng-template let-item="item">
          {{ item.quantity }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'percent' | translate"
        id="percent"
        [hiddenByDefault]="false"
      >
        <ng-template let-item="item">
          {{ item.percent }}%
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'actions' | translate"
        id="actions"
        [hiddenByDefault]="false"
      >
        <ng-template let-item="item">
            <button class="button primary mr-1" (click)="update(item)">Edit</button>
            <button class="button danger" (click)="remove(item)">Delete</button>
        </ng-template>
      </vdr-dt2-column>
    </vdr-data-table-2>
  </div>
</vdr-card>
